/** biome-ignore-all lint/nursery/noRestrictedElements: <overwriting the defaults> */
'use client';

/**
 * @description if we want we could make these to be server components in the future just remove the 'use client' and you can this as async component
 */
import type React from 'react';
import { useEffect, useRef } from 'react';
import { cn } from '@/app_lib/utils/utils';

export const Iframe = (props: React.IframeHTMLAttributes<HTMLIFrameElement>) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { src, title, style, ...rest } = props;

  useEffect(() => {
    const iframe = iframeRef.current as HTMLIFrameElement;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          iframe.src = src || '';
          observer.unobserve(iframe);
        }
      },
      {
        threshold: 1,
      },
    );

    observer.observe(iframe);

    return () => {
      observer.disconnect();
    };
  }, [src]);

  if (!src) {
    return null;
  }

  const styles = style as Record<string, string> | undefined;
  let width = styles?.width;
  let height = styles?.height;
  // in height is a percentage change it to the correponding pixel value
  if (height?.includes('%')) {
    const percentage = Number(height.replace('%', ''));
    const parentHeight = iframeRef.current?.parentElement?.clientHeight || 600;
    height = `${(percentage / 100) * parentHeight}px`;
  }
  if (width?.includes('%')) {
    const percentage = Number(width.replace('%', ''));
    const parentWidth = iframeRef.current?.parentElement?.clientWidth || 800;
    width = `${(percentage / 100) * parentWidth}px`;
  }
  const defaultHeight = 600;
  const widthNum = width ? Number(width.replace('px', '')) : undefined;
  const heightNum = height ? Number(height.replace('px', '')) : defaultHeight;

  return (
    <div className={cn('grid w-full relative border-none')}>
      <iframe
        className='w-full'
        height={heightNum}
        loading='lazy'
        ref={iframeRef}
        src={src}
        title={title}
        width={widthNum}
        {...rest}
      />
    </div>
  );
};
